import { Button } from "@mui/material";
import React from "react";
import { isMobile } from "react-device-detect";

const HomeBtn = () => {
  return (
    <Button
      fullWidth={(isMobile || window.innerWidth <= 785) && true}
      onClick={() => (window.location.href = "/area_controller/home")}
      sx={{ color: !isMobile && "white", borderBottom: isMobile && "1px solid #ddd", mb: isMobile && 1 }}
    >
      HOME
    </Button>
  );
};

export default HomeBtn;